import React from 'react';

import {Header} from '@pages/EployersControl/Header';
import {Wrapper} from '@pages/EployersControl/styled';
import {EmployersList} from '@pages/EployersControl/Table';
import {Page} from '@shared/ui/Page';

import {CreateEmployeeModal} from './CreateEmployeeModal';
import {EditEmployeeModal} from './EditEmployeeModal';

export const EmployersControlPage = () => (
    <Page>
        <Wrapper>
            <CreateEmployeeModal />
            <EditEmployeeModal />
            <Header />
            <EmployersList />
        </Wrapper>
    </Page>
);
